import logoSymbol from '../../assets/logo-spassu-symbol.svg';

export const LogoIcon = () => (
  <img src={logoSymbol} alt="Spassu" style={{ width: 'auto', height: 28 }} />
);
